module.exports = __webpack_public_path__ + "e3fb863366a9cd105a251283b4fdc218.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/card1.png
 ** module id = 208
 ** module chunks = 1
 **/